export type RelationEndpoint =
  | 'none'
  | 'vee'
  | 'circle'
  | 'diamond'
  | 'hollowDiamond'
  | 'hollowTriangle';

export const RELATION_LINE_WIDTH = 1.5;
/** Fraction of each endpoint occupied by the connecting line. */
export const RELATION_ENDPOINT_BASE_RATIO = 0.5;
const diamond = { length: 5, width: 4 };
const outline = 0.8;

/** Endpoint dimensions relative to line thickness, shared by SVG and Sigma. */
export const RELATION_ENDPOINT_GEOMETRY = {
  vee: { length: 5, width: 4, notch: 0.4 },
  circle: { length: 4, width: 5 },
  diamond,
  hollowDiamond: { ...diamond, outline },
  hollowTriangle: { length: 6, width: 5, outline },
} as const;

const ENDPOINTS: Record<
  string,
  { head: RelationEndpoint; tail: RelationEndpoint }
> = {
  association: { head: 'vee', tail: 'none' },
  aggregation: { head: 'none', tail: 'hollowDiamond' },
  composition: { head: 'none', tail: 'diamond' },
  dependence: { head: 'circle', tail: 'none' },
  inheritance: { head: 'hollowTriangle', tail: 'none' },
};

/** UML endpoints and line pattern shared by canvases and their legends. */
export const getRelationAppearance = (name?: string, inherited = false) => ({
  ...(ENDPOINTS[name ?? ''] ?? { head: 'none', tail: 'none' }),
  dashSize: inherited ? 6 : 2,
  gapSize: inherited ? 4 : name === 'dependence' ? 3 : 0,
});